import { defineNuxtPlugin } from "nuxt/app";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import "dayjs/locale/cs";

dayjs.extend(isoWeek);
dayjs.locale("cs");

export default defineNuxtPlugin(() => {});
